import { Model } from 'vuex-orm';

import User from '../user/model';

export default class Timesheet extends Model {
  static entity = 'timesheets';

  static fields() {
    return {
      id: this.attr(null),
      user_id: this.attr(null),
      status: this.attr(''),
      week: this.attr(''),
      year: this.attr(''),
      note: this.attr(''),
      bms_hours: this.attr(null),
      created_at: this.attr(''),
      updated_at: this.attr(''),
      user: this.belongsTo(User, 'user_id'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/timesheet/model.js